/* eslint-disable no-nested-ternary */
/* eslint-disable prettier/prettier */
import { styled } from '@mui/material/styles';
import { Button, MenuItem, Slider } from '@mui/material';
import {
  HEADER_HEIGHT,
  AUDIO_PLAYER_HEIGHT,
  CHARACTER_LIMIT_BANNER_HEIGHT,
} from '@src/constants/project';
import { COLOR } from '@src/styles/color';
import { FLASH_SALE_BANNER_HEIGHT } from '@src/styles/config';

export const StyledContent = styled('div')`
  position: relative;
  background-color: #f4f5f7;
  box-sizing: border-box;
  height: calc(
    100vh - ${HEADER_HEIGHT}px -
      ${(props) =>
        props.hasCharacterLimitBanner ? CHARACTER_LIMIT_BANNER_HEIGHT : 0}px -
      ${(props) =>
        props.isShowHeaderBanner ? FLASH_SALE_BANNER_HEIGHT : '0'}px
      ${(props) =>
        props.isFilteringBlockStatus || props.hasSelectedBlock
          ? 0
          : AUDIO_PLAYER_HEIGHT}px
  );

  overflow: hidden;
  /* Custom scrollbar (Firefox) */
  .custom-scrollbar {
    scrollbar-width: thin; /* Firefox */
    scrollbar-color: #c6c6c6 transparent; /* thumb color | track color */
    scrollbar-gutter: stable;
  }

  .resize-handle {
    width: 16px !important;
    background-color: ${COLOR.white};
    border-left: 0.5px solid rgba(30, 22, 78, 0.16);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: col-resize;
    flex-shrink: 0;

    .handle-indicator {
      display: flex;
      align-items: center;
      gap: 4px;
    }

    .handle-line {
      width: 2px;
      height: 48px;
      background-color: rgba(30, 22, 78, 0.16);
      border-radius: 100px;
    }
  }
`;

export const StyledActionWarning = styled('div')`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0px 24px;
  .btn-non-vbee-warning {
    text-transform: none;
    height: 40px;
    border-radius: 12px;
  }
`;

export const StyledContentBlockWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 0px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  padding: 0px 0px ${({ isLastBlock }) => (isLastBlock ? '0px' : '32px')};
  align-items: center;
`;

export const StyledOrdinalNumberBlock = styled('div')`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 4px;
`;

export const StyledInfoBlock = styled('div')`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const StyledContentBlock = styled('div')`
  max-width: 1200px;
  display: flex;
  gap: 8px;
  width: 100%;
  align-items: center;
  margin-bottom: ${(props) => (props.isLastParagraphId ? '40px' : '0px')};
  /* Animation for new blocks */
  ${(props) =>
    props.isNewBlock &&
    `
    animation: zoomIn 0.2s ease-in-out;
    transform-origin: center;
  `}

  @keyframes zoomIn {
    from {
      transform: scale(0.1);
      opacity: 0;
    }
    to {
      transform: scale(1);
      opacity: 1;
    }
  }

  .editor-toolbar {
    display: flex;
    align-items: center;
    padding: ${(props) =>
      !props.isFocusingOnBlock ? '0px 12px 0px 12px' : '0px 12px 12px 12px'};

    .convert-progress {
      display: flex;
      justify-content: center;
      align-items: center;

      .inprogress-icon-container {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 40px;
        height: 40px;
      }

      .inprogress-icon {
        color: #007aff;
      }
    }

    .editor-toolbar-btn {
      padding: 8px;
      color: ${COLOR.darkGray};
      cursor: pointer;
    }

    .success-icon {
      color: #007aff;
      animation: fadeIn 3s ease-in-out;
      opacity: 0;
      width: 40px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    @keyframes fadeIn {
      from {
        opacity: 1;
      }
      to {
        opacity: 0;
        display: none;
      }
    }

    .disabled-btn {
      cursor: not-allowed;
      opacity: 0.32;
    }

    .icon {
      padding: 8px;
    }
  }
  .editor-toolbar-new-ui {
    padding: ${(props) =>
      !props.isFocusingOnBlock ? '12px 12px 0px 12px' : '0px 12px 12px 12px'};
  }
  .none-drag {
    width: 1px;
  }

  .drag {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: 8px 8px 8px 16px;
    .drag-icon-wrapper {
      cursor: pointer;
    }
    .disabled-move {
      cursor: not-allowed;
      opacity: 0.32;
    }
  }
  .select-block {
    .checkbox-color {
      color: ${COLOR.indigo.default};
    }
  }

  .select-block-new-ui-v2 {
    margin-top: 22px !important;
  }

  .drag-new-ui {
    padding: 0px 2px 0px 6px;
  }

  .drag-new-ui-v2 {
    margin-top: 22px !important;
  }

  .block-wrapper {
    background-color: ${COLOR.white};
    border-radius: 12px;
    width: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    max-width: 1350px;
    gap: 8px;
    border: ${(props) =>
      props?.isError
        ? '1px solid #FF3B30'
        : props.isFocusingOnBlock || props.isHighlight
        ? '1px solid #1E164E'
        : `1px solid ${COLOR.label['16']}`};
    .editor-wrapper {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      gap: 8px;
      width: 100%;
      flex: 1;
      max-width: 1350px;
    }

    .editor-wrapper-new-ui {
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      gap: 24px;
      padding: 0px 8px 0px 8px;
      border-radius: 8px;
      box-sizing: border-box;

      .slide-thumbnail {
        flex-shrink: 0;
        width: 214px;
        height: 120px;
        border-radius: 8px;
        border: 0.25px solid rgba(30, 22, 78, 0.16);
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }

      .slide-thumbnail-placeholder {
        flex-shrink: 0;
        width: 214px;
        height: 120px;
        border-radius: 8px;
        border: 0.25px solid rgba(30, 22, 78, 0.16);
        background-color: ${COLOR.backgroundDefault};
      }

      .text-column {
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: 4px;
        align-self: stretch;
        min-width: 0;
        padding: 4px 0;
      }
    }
  }
  .voice {
    display: ${(props) => (props.isFocusingOnBlock ? 'none' : 'flex')};
  }

  .block-toolbar-wrapper {
    display: ${(props) => (props.isFocusingOnBlock ? 'flex' : 'none')};
    padding: 12px 12px 0px 12px;
    justify-content: space-between;
    align-items: center;
    flex-direction: row;
    flex: 1;
    width: calc(100% - 32px);
    .config-toolbar-voice {
      display: flex;
      align-items: center;
    }
    .config-toolbar {
      display: flex;
      gap: 8px;
      align-items: center;
    }

    .choose-voice {
      display: flex;
      align-items: center;
      cursor: pointer;
      text-transform: capitalize;
      padding: 4px 6px;
      border-radius: 16px;

      &:hover,
      &:focus {
        background: ${COLOR.secondary[80]};
      }
    }

    .invalid-voice-name {
      margin-left: 10px;
      color: ${COLOR.redPrimary};
    }

    .voice-name {
      margin-left: 10px;
      color: ${COLOR.darkBlue};
    }

    .returning-error-icon {
      color: ${COLOR.redPrimary};
      font-size: 14px;
      cursor: pointer;
      margin-left: -2px;
      margin-right: 4px;
    }

    .margin-right {
      margin-right: 6px;
    }

    .char-count {
      display: flex;
      align-items: center;
      gap: 8px;

      .text {
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        letter-spacing: -0.4px;
        text-align: right;
        vertical-align: middle;
      }

      .double-char {
        padding: 2px 8px;
        border-radius: 48px;
        background-color: #1e164e14;
        color: ${COLOR.indigo.default};
      }

      .current-char-count {
        color: ${COLOR.blueV2};
      }

      .exceed-block-char-icon {
        background-color: #ff3b3014;
        width: 20px;
        height: 20px;
        padding: 4px;
        border-radius: 8px;
      }

      .total-char-count {
        color: ${COLOR.darkGray};
      }

      .exceed-block-max-char {
        color: ${COLOR.danger};
      }
    }
  }

  /* V2 Block UI Improvement overrides */
  .block-wrapper-v2 {
    padding: 12px;
    box-sizing: border-box;
    gap: 4px;

    .block-toolbar-wrapper {
      padding: 0px !important;
      .convert-progress{
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }

    .editor-wrapper:not(.editor-wrapper-new-ui) {
      gap: 0px;
    }

    .editor-container {
      padding: 4px 0px 4px 12px !important;
      border-left: 1px solid ${(props) => (props.isFocusingOnBlock ? COLOR.darkGray : COLOR.label2['24'])};
    }
    .disabled-btn {
      cursor: not-allowed;
      opacity: 0.32;
    }
    .editor-toolbar-btn {
      padding: 8px;
      color: ${COLOR.darkGray};
      cursor: pointer;
    }

    .editor-toolbar {
      padding: 0px !important;
      
    }

    /* Override StyledBlockEditor padding - non-presentation */
    .editor-wrapper:not(.editor-wrapper-new-ui) > div:first-child {
      padding: 0px 8px !important;
      min-height: auto;
    }

    /* Override StyledBlockEditor padding - presentation */
    .editor-wrapper-new-ui .text-column > div:first-child {
      padding: 0 !important;
      min-height: auto;
    }

    .select-block-new-ui-v2 {
      margin-top: 0px !important;
      margin-left: 0px;

      .MuiCheckbox-root {
        padding: 4px;
      }
    }

   .char-count {
      display: flex;
      align-items: center;
      gap: 8px;

      .text {
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        letter-spacing: -0.4px;
        text-align: right;
        vertical-align: middle;
      }

      .double-char {
        padding: 2px 8px;
        border-radius: 48px;
        background-color: #1e164e14;
        color: ${COLOR.indigo.default};
      }

      .current-char-count {
        color: ${COLOR.blueV2};
      }

      .exceed-block-char-icon {
        background-color: #ff3b3014;
        width: 20px;
        height: 20px;
        padding: 4px;
        border-radius: 8px;
      }

      .total-char-count {
        color: ${COLOR.darkGray};
      }

      .exceed-block-max-char {
        color: ${COLOR.danger};
      }
    }
    /* Vertical divider between checkbox and voice selector */
    .block-header-divider {
      width: 1px;
      height: 24px;
      background-color: rgba(60, 60, 67, 0.16);
      flex-shrink: 0;
    }

    .voice-name {
      font-weight: 500;
      letter-spacing: -0.4px;
      color: rgba(30, 22, 78, 0.8);
    }

    .split-block-btn {
      &.Mui-disabled {
        opacity: 0.3;
      }
    }

    .char-count {
      .text {
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        letter-spacing: -0.4px;
        text-align: right;
        color: ${COLOR.darkGray};
      }

      .current-char-count {
        color: ${COLOR.blueV2};
      }

      .total-char-count {
        color: ${COLOR.darkGray};
      }

      .exceed-block-max-char {
        color: ${COLOR.danger};
      }
    }
  }
`;


export const StyledBreakTime = styled(Button)`
  display: flex;
  align-items: center;
  gap: 4px;
  border-radius: 12px;
  padding: 4px 6px;
  &:hover {
    background-color: ${COLOR.indigo[8]};
  }
  text-transform: none;

  .icon {
    color: ${COLOR.indigo[80]};
    padding: 2px 2px;
  }

  .btn-text {
    font-weight: 510;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: -0.4px;
    color: ${COLOR.indigo[80]};
  }

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .text {
      font-weight: 510;
      font-size: 14px;
      line-height: 20px;
      letter-spacing: -0.4px;
      color: ${COLOR.darkGray};
    }

    .delete-text {
      color: #ff3b30;
    }
  }
`;

export const StyledBreakTimePopper = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 16px;

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .text {
      font-weight: 510;
      font-size: 14px;
      line-height: 20px;
      letter-spacing: -0.4px;
      color: ${COLOR.darkGray};
    }

    .delete-text {
      color: #ff3b30;
    }

    .disabled-delete-text {
      cursor: none;
      opacity: 0.32;
    }
  }

  .breaktime-wrapper {
    display: flex;
    flex-direction: column;
    gap: 16px;

    .breaktime-option-wrapper {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-bottom: 16px;
      border-bottom: 1px solid ${COLOR.label['16']};

      .breaktime-option {
        padding: 2px 8px;
        border-radius: 8px;
        border: 1px solid ${COLOR.label['16']};
        cursor: pointer;
        width: 44px;
      }

      .breaktime-option-text {
        font-weight: 500;
        font-size: 14px;
        line-height: 20px;
        letter-spacing: -0.4px;
        vertical-align: middle;
        text-align: center;
        color: ${COLOR.darkGray};
      }

      .active-breaktime-option {
        border: 1px solid #1e164e;
        background-color: #1e164e14;
      }
    }

    .breaktime-input-wrapper {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .text-field-breaktime {
        background-color: ${COLOR.white};
        width: 180px;

        .MuiOutlinedInput-root {
          width: 180px;
          height: 40px;
          gap: 8px;
          padding: 8px 8px;
          border-radius: 8px;
        }

        .MuiInputLabel-root {
          font-size: 14px;
        }
      }

      .custom-btn {
        background-color: ${COLOR.primary};
        text-transform: none;
        color: ${COLOR.indigo[100]};
        font-weight: 500;
        font-size: 14px;
        line-height: 20px;
        letter-spacing: -0.4px;
        text-align: center;
        vertical-align: middle;
        padding: 8px 12px;
        border-radius: 8px;
        height: 40px;

        &:focus {
          background-color: #ffd60a;
        }
        &:hover {
          background-color: #ffe66c;
        }

        &:disabled {
          opacity: 0.32;
        }
      }
    }
  }
`;

export const StyledBlockEditor = styled('div')`
  display: flex;
  justify-content: space-between;
  min-height: 40px;
  flex: 1;
  align-items: flex-start;
  padding: 0px 12px 12px 12px;

  .voice {
    display: ${(props) => (props.isFocusingOnBlock ? 'none' : 'flex')};
    justify-content: center;
    align-items: center;
    max-height: 40px;
    margin-top: 1px;
  }

  .editor-container {
    flex: 1;
    padding: 12px 8px;
    padding-left: 30px;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: -0.4px;
    vertical-align: middle;
    word-break: break-word;
    overflow-wrap: break-word;
  }

  .character-exceed {
    color: ${COLOR.danger};
  }

  .black-word-highlight {
    color: ${COLOR.darkBlue};
    background-color: ${COLOR.error};
  }
`;

export const StyledAddBlock = styled('div')`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  .add-btn {
    text-transform: none;
    border-radius: 8px;
    border: 1px solid ${COLOR.indigo[32]};
    background-color: ${COLOR.white};
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: -0.4px;
    text-align: center;
    vertical-align: middle;
    &:hover {
      background-color: ${COLOR.charcoal};
    }
  }
`;

export const StyledBlockAudioPlayer = styled('div')`
  padding: 4px 16px;
  border-radius: 480px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #1e164e0a;

  .audio-progress-wrapper {
    flex: 1;
    display: flex;
    align-items: center;
    gap: 16px;

    .audio-progress-duration {
      width: 34px;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      letter-spacing: -0.4px;
    }
  }
`;

export const StyledBlockAudioPlayerProgress = styled(Slider)`
  height: 4px;
  width: 100%;
  padding: 0px !important;

  & .MuiSlider-track {
    border: none;
    color: ${COLOR.indigo[8]};
  }

  & .MuiSlider-rail {
    color: ${COLOR.indigo[8]};
  }

  & .MuiSlider-thumb {
    background-color: ${COLOR.primary};
  }
`;

export const StyledMenuItem = styled(MenuItem)`
  color: #1e164e;
  font-size: 14px;
  height: 40px;
  box-sizing: border-box;
  padding: 10px 16px 10px 16px;
  font-weight: 500;

  .option-btn {
    width: 40px;
    height: 40px;
    padding: 12px;
    &:hover {
      background-color: transparent;
    }
  }
`;

export const StyledEditNameBlock = styled('input')`
  height: 24px;
  padding: 2px 4px;
  box-sizing: border-box;
  border: 1px solid transparent;
  border-radius: 4px;
  width: 245px;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.4px;
  color: #1c1c1ea3;
  outline: none;
  background-color: transparent;
  :focus {
    background-color: ${(props) => (props.isError ? '#FF3B3014' : '#1e164e0a')};
    border: ${(props) =>
      props.isError
        ? `1px solid ${COLOR.textRejected}`
        : '1px solid #1e164e29'};
  }
  :hover {
    background-color: ${(props) => (props.isError ? '#FF3B3014' : '#1e164e0a')};
    border: ${(props) =>
      props.isError
        ? `1px solid ${COLOR.textRejected}`
        : '1px solid #1e164e29'};
  }
`;

export const StyledWarningButton = styled('button')({
  width: '40px',
  height: '40px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '8px',
  border: 'none',
  borderRadius: '50%',
  background: 'transparent',
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: COLOR.orangeV2[8],
  },
});

export const StyledPopoverContent = styled('div')({
  display: 'flex',
  flexDirection: 'column',
});

export const StyledPopoverHeader = styled('div')({
  display: 'flex',
  alignItems: 'center',
  padding: '12px',
  borderBottom: `0.5px solid ${COLOR.indigo[16]}`,
});

export const StyledPopoverBody = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: '10px',
  padding: '12px',
});

export const StyledNoteTip = styled('div')`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 12px;
  border-radius: 8px;
  background-color: ${COLOR.bluev2[8]};
  width: 100%;
  box-sizing: border-box;

  .note-tip-icon {
    width: 20px;
    height: 20px;
    color: ${COLOR.blueV2};
    flex-shrink: 0;
  }

  .note-tip-text {
    font-size: 14px;
    line-height: 20px;
    color: ${COLOR.darkGray};

  }

  .note-tip-link {
    display: inline;
    border: none;
    background: none;
    padding: 0;
    margin: 0 0 0 4px;
    cursor: pointer;
    font: inherit;
    line-height: inherit;
    color: ${COLOR.blueV2};
    text-decoration: underline;
    vertical-align: baseline;
  }
`;
